import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpService } from '../http.service';
import { HttpRequestHandler } from '../../models/http-model';
const HEADERS = {};

@Injectable()
export class BooksParameterService {

  static ENV = environment;
  constructor(private httpService: HttpService) {
    HEADERS['Content-Type'] = 'application/json';
  }

  public saveLedgers(data, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(`${BooksParameterService.ENV.environment.API.ledgers}`, data, httpRequesthandler);
  }
  public getledgers(data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(`${BooksParameterService.ENV.environment.API.ledgers}/${data.value}`, httpRequesthandler);
  }
  public get_ledgers(httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(BooksParameterService.ENV.environment.API.get_ledger, httpRequesthandler);
  }
  public remove(ledger_id: number, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.delete(`${BooksParameterService.ENV.environment.API.ledgers}/${ledger_id}`, httpRequesthandler);
  }
  public mergeLedgers(data, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.post(`${BooksParameterService.ENV.environment.API.merge_ledgers}`, data, httpRequesthandler);
  }

  public getOperatingUnit(ledger_id: number, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.get(`${BooksParameterService.ENV.environment.API.get_operating_unit_by_ledger}/${ledger_id}`, httpRequesthandler);
  }

  public UpdateOperatingUnit(ledger_id: number, data: any, httpRequesthandler: HttpRequestHandler): void {
    httpRequesthandler.headers = HEADERS;
    this.httpService.put(`${BooksParameterService.ENV.environment.API.save_gl_user_ou}/${ledger_id}`, data, httpRequesthandler);
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/admin/books-parameter.service.ts